import { Component, Show } from "solid-js";
import { Tooltip } from "../ui";

export interface WhatsNewButtonProps {
  hasUnread: boolean;
  onClick: () => void;
}

export const WhatsNewButton: Component<WhatsNewButtonProps> = (props) => {
  return (
    <Tooltip content="What's new" position="bottom">
      <button
        onClick={props.onClick}
        class="relative p-1.5 text-ink-2 hover:text-ink hover:bg-sunken rounded transition-colors focus-ring"
        aria-label={
          props.hasUnread ? "What's new — unread updates" : "What's new"
        }
      >
        {/* Heroicon v1: speakerphone (outline 24x24) */}
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
          />
        </svg>
        {/* Unread dot */}
        <Show when={props.hasUnread}>
          <span
            class="absolute top-1 right-1 w-2 h-2 bg-ink rounded-full"
            aria-hidden="true"
          />
        </Show>
      </button>
    </Tooltip>
  );
};
